import { Icon, isIconName, type IconName } from "@openanalyst-ai/ui/icon"
import type { StarterPanelItem, StarterPanelView } from "@/services/project-starters"

const iconName = (item: StarterPanelItem): IconName => {
  if (item.icon && isIconName(item.icon)) return item.icon
  if (item.icon === "search") return "magnifying-glass"
  if (item.icon === "wrench") return "settings-gear"
  return "sparkles"
}

export function StarterPanel(props: {
  panel: StarterPanelView
  onAction: (item: StarterPanelItem) => void
}) {
  return (
    <div data-starter-panel="" class="w-full max-w-220 pt-2">
      {props.panel.sections.map((section) => (
        <section data-starter-panel-section="" class="w-full">
          <div data-starter-panel-section-title="" class="mb-2 text-left text-12-medium text-text-weak">
            {section.title}
          </div>
          <div
            data-starter-panel-grid={section.layout ?? "card-grid"}
            class={section.layout === "list" ? "flex flex-col gap-2" : "grid grid-cols-1 gap-2 sm:grid-cols-3"}
          >
            {section.items.map((item) => {
              const itemIconName = iconName(item)
              return (
                <button
                  type="button"
                  data-starter-panel-card=""
                  data-starter-panel-source={item.source}
                  class="group min-h-30 rounded-md border border-border-weak-base bg-background-base px-3 py-3 text-left transition-colors hover:border-border-strong-base hover:bg-surface-raised-base focus:outline-none focus:ring-1 focus:ring-border-active"
                  onClick={() => props.onAction(item)}
                  aria-label={item.title}
                >
                  {item.image ? (
                    <div
                      data-starter-panel-image=""
                      data-icon-token={itemIconName}
                      class="mb-3 aspect-[16/9] overflow-hidden rounded border border-border-weak-base bg-background-secondary"
                    >
                      <img src={item.image} alt="" class="h-full w-full object-cover" loading="lazy" />
                    </div>
                  ) : null}
                  <div class="flex items-start gap-2">
                    {item.image ? null : (
                      <div
                        data-starter-panel-icon=""
                        data-icon-token={itemIconName}
                        class="mt-0.5 size-6 shrink-0 rounded-md border border-border-weak-base bg-background-secondary grid place-items-center text-text-weak group-hover:text-text-base"
                      >
                        <Icon name={itemIconName} size="small" />
                      </div>
                    )}
                    <div data-starter-panel-copy="" class="min-w-0">
                      <div data-starter-panel-title="" class="text-13-medium leading-5 text-text-strong">
                        {item.title}
                      </div>
                      <div data-starter-panel-description="" class="mt-1 text-12-regular leading-5 text-text-weak">
                        {item.description}
                      </div>
                      {item.detail ? (
                        <div data-starter-panel-detail="" class="mt-2 text-11-regular leading-4 text-text-muted">
                          {item.detail}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </button>
              )
            })}
          </div>
        </section>
      ))}
    </div>
  )
}
